import _ from 'lodash';
import { apiSearch, apiFetch } from './utility';

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'dataRecord.add',
			//listNameToUpdate : 'dataRecordIds',
			params,
			dispatch,
			successMessage : `DGS Data was updated successfully. 
				Click continue to return to the dashboard`,
			onSuccessRedirectTo : '/dashboard',
			callback : function (err) {
				if (err) { return callback(err); }

				apiSearch({
					base : 'dataRecord',
					params : { onlyLatest : true },
					dispatch : dispatch,
					callback : callback,
				});

			},
		});
	};
};

export const search = (p = {}) => {
	const callback = p.callback || _.noop;
	const onlyLatest = p.onlyLatest;

	return dispatch => {
		apiSearch({
			base : 'dataRecord',
			params : { onlyLatest },
			dispatch : dispatch,
			callback : callback,
		});
	};
};
